"use client";
import dynamic from "next/dynamic";

const ReactPlayerDynamicWrapper = dynamic(() => import("react-player"), {
  ssr: false,
  loading: () => <></>,
});

export default ReactPlayerDynamicWrapper;
